import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { nextPowerOfTwo as t } from "../../../../../core/mathUtils.js";
import { isSome as r } from "../../../../../core/maybe.js";
import { c as e } from "../../../../../chunks/mat3f32.js";
import { f as o } from "../../../../../chunks/vec4f32.js";
import i from "../../../../webgl/BufferObject.js";
import "../../../../webgl/FramebufferObject.js";
import "../../../../../core/has.js";
import "../../../../webgl/checkWebGLError.js";
import "../../../../webgl/enums.js";
import "../../../../../chunks/builtins.js";
import "../../../../webgl/Texture.js";
import s from "../../../../webgl/VertexArrayObject.js";
import { VTL_TEXTURE_BINDING_UNIT_SPRITES as a, VTL_HIGH_RES_CUTOFF as n } from "../definitions.js";
import { WGLDrawPhase as c } from "../enums.js";
import { u32to4Xu8 as m } from "../number.js";
import f from "./WGLBrush.js";

var l = /*#__PURE__*/function (_f) {
  _inherits(l, _f);

  var _super = _createSuper(l);

  function l() {
    var _this;

    _classCallCheck(this, l);

    _this = _super.apply(this, arguments), _this._color = o(1, 0, 0, 1), _this._patternMatrix = e(), _this._programOptions = {
      id: !1,
      pattern: !1
    };
    return _this;
  }

  _createClass(l, [{
    key: "dispose",
    value: function dispose() {
      this._vao && (this._vao.dispose(), this._vao = null);
    }
  }, {
    key: "drawMany",
    value: function drawMany(e, o) {
      var i = e.context,
          s = e.painter,
          f = e.styleLayerUID;

      this._loadWGLResources(e);

      var _l = e.displayLevel,
          u = e.styleLayer,
          p = u.backgroundMaterial,
          _ = s.vectorTilesMaterialManager,
          h = u.getPaintValue("background-color", _l),
          d = u.getPaintValue("background-opacity", _l),
          g = u.getPaintValue("background-pattern", _l),
          b = void 0 !== g,
          j = h[3] * d,
          v = 1 | window.devicePixelRatio,
          x = e.spriteMosaic;
      var y, M;
      var w = v > n ? 2 : 1,
          U = e.drawPhase === c.HITTEST,
          k = this._programOptions;
      k.id = U, k.pattern = b;

      var L = _.getMaterialProgram(i, p, k);

      if (i.bindVAO(this._vao), i.useProgram(L), b) {
        var _t = x.getMosaicItemPosition(g, !0);

        if (r(_t)) {
          var _e = _t.tl,
              _o = _t.br,
              _s = _t.page;
          y = _o[0] - _e[0], M = _o[1] - _e[1];

          var _n = x.getPageSize(_s);

          r(_n) && (x.bind(i, 9729, _s, a), L.setUniform4f("u_tlbr", _e[0], _e[1], _o[0], _o[1]), L.setUniform2fv("u_mosaicSize", _n), L.setUniform1i("u_texture", a));
        }

        L.setUniform1f("u_opacity", d);
      } else this._color[0] = j * h[0], this._color[1] = j * h[1], this._color[2] = j * h[2], this._color[3] = j, L.setUniform4fv("u_color", this._color);

      if (L.setUniform1f("u_depth", u.z || 0), U) {
        var _t2 = m(f + 1);

        L.setUniform4fv("u_id", _t2);
      }

      var _iterator = _createForOfIteratorHelper(o),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r = _step.value;

          if (L.setUniform1f("u_coord_range", _r.rangeX), L.setUniformMatrix3fv("u_dvsMat3", _r.transforms.dvs), b) {
            var _e2 = Math.max(Math.pow(2, Math.round(_l) - _r.key.level), 1),
                _o2 = w * _r.width * _e2,
                _i = _o2 / t(y),
                _s2 = _o2 / t(M);

            this._patternMatrix[0] = _i, this._patternMatrix[4] = _s2, L.setUniformMatrix3fv("u_pattern_matrix", this._patternMatrix);
          }

          i.setStencilFunction(514, _r.stencilRef, 255), i.drawArrays(5, 0, 4);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_loadWGLResources",
    value: function _loadWGLResources(t) {
      if (this._vao) return;
      var r = t.context,
          e = t.styleLayer,
          o = e.backgroundMaterial,
          a = new Int8Array([0, 0, 1, 0, 0, 1, 1, 1]),
          n = i.createVertex(r, 35044, a),
          c = new s(r, o.getAttributeLocations(), o.getLayoutInfo(), {
        geometry: n
      });
      this._vao = c;
    }
  }]);

  return l;
}(f);

export { l as WGLBrushVTLBackground };